import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/common/Reveal";
import SectionLabel from "@/components/common/SectionLabel";
import { SERVICES } from "@/data/site";

export default function ServicesSection() {
  return (
    <section data-testid="services-section" className="bg-white py-24 md:py-32">
      <div className="container-gema">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Reveal>
              <SectionLabel index="03" dark={false}>Nuestros Servicios</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="heading-lg text-black mt-6 max-w-2xl">
                Soluciones especializadas por sector
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <Link to="/servicios" data-testid="services-view-all" className="btn-outline-dark">
              Ver Todos los Servicios
            </Link>
          </Reveal>
        </div>

        <RevealGroup className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Wrench;
            return (
              <RevealItem key={s.slug}>
                <Link
                  to={`/servicios/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group relative block overflow-hidden border border-black/10 bg-black h-[360px]"
                >
                  <img
                    src={s.image}
                    alt={s.name}
                    className="absolute inset-0 w-full h-full object-cover opacity-60 transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/10" />
                  <div className="relative z-10 h-full flex flex-col justify-between p-8">
                    <div className="flex items-start justify-between">
                      <Icon className="h-10 w-10 text-white" strokeWidth={1.5} />
                      <span className="font-mono text-xs text-white/50 tracking-widest">0{i + 1}</span>
                    </div>
                    <div>
                      <h3 className="font-heading font-black uppercase text-2xl text-white">{s.name}</h3>
                      <p className="text-white/60 text-sm mt-3 max-w-md leading-relaxed line-clamp-3">{s.short}</p>
                      <span className="inline-flex items-center gap-2 mt-5 font-heading text-sm font-bold uppercase tracking-wider text-gema-red">
                        Ver Servicios
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                      </span>
                    </div>
                  </div>
                </Link>
              </RevealItem>
            );
          })}
        </RevealGroup>
      </div>
    </section>
  );
}
